var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-y-auto"},[_c('player-drilldown-summary'),_c('player-drilldown-requests',{staticClass:"hidden"}),_c('player-drilldown-bookings',{staticClass:"hidden"}),_c('player-drilldown-booking-billings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }